export default __webpack_public_path__ + "static/apeswap-364dc7a9986c77d2c95b427294fc2b2a.svg";